<div ngbDropdown class="rs-common-dropdown rs-lang-dropdown">
    <a class="nav-link" id="langDropdownMenuButton" role="button" ngbDropdownToggle>
        <span>{{ languageSelected }}</span>
    </a>
    <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="langDropdownMenuButton">
        <ng-template ngFor let-lang  [ngForOf]="supportedLanguages">
            <a class="dropdown-item" (click)="changeLanguage(lang.systemLanguageValue)" *ngIf="lang !== languageSelected">{{ lang.systemLanguageDesc }}</a>
        </ng-template>
    </div>
</div>